import { controlToastState } from "risa-oasis-ui_v2";
import { getFileDownloadUrl } from "../../../../../api/firebase/firestoreService";

export const downloadCsv = async (
  filePath: string,
  fileName?: string,
): Promise<void> => {
  try {
    // Get the download URL from Firebase Storage
    const downloadUrl = await getFileDownloadUrl(filePath);

    if (!downloadUrl) {
      console.error("Failed to get download URL");
      controlToastState("nar-csv-download-failure");
      return;
    }

    // Create a temporary anchor element to trigger download
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = fileName ?? filePath.split("/").pop() ?? "download.csv";
    link.target = "_blank";
    link.rel = "noopener noreferrer";

    // Append to body, click, and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    controlToastState("nar-csv-download-success");
  } catch (error) {
    console.error("Error downloading CSV:", error);
    controlToastState("nar-csv-download-failure");
    throw error;
  }
};
